import type { AccordionProps } from '@mantine/core';
import { Accordion, Group } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

import useStyles from './Accordion.styles';


type AccountAccordionProps = Omit<AccordionProps, 'title'> & {
  className?: string;
  name: string;
  title: React.ReactNode;
  subtitle?: string;
  subtitleComponent?: React.ReactNode;
  children: React.ReactNode;
  isGrey?: boolean;
  isDark?: boolean;
};

function CustomAccordion({
  className,
  name,
  title,
  subtitle,
  subtitleComponent,
  children,
  isGrey,
  isDark,
  ...accordionProps
}: AccountAccordionProps) {
  const { cx, classes } = useStyles();

  return (
    <Accordion className={cx(classes.accordion, className, [isGrey && 'isGrey', isDark && 'isDark'])} {...accordionProps}>
      <Accordion.Item value={name} className={classes.item}>
        <Accordion.Control className={classes.control}>
          <Group noWrap>
            <>
              {typeof title === 'string' ? (
                <Text variant="title-medium" className={classes.title}>
                  {title}
                </Text>
              ) : (
                title
              )}
              {subtitleComponent ??
                (subtitle ? <Text size="sm" color="dimmed" weight={400}>{subtitle}</Text> : null)}
            </>
          </Group>
        </Accordion.Control>
        <Accordion.Panel className={classes.panel}>{children}</Accordion.Panel>
      </Accordion.Item>
      <hr className={classes.divider} />
    </Accordion>
  );
}

export default CustomAccordion;
